import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* padding: 16px 15px; */
  border-radius: 12px;
  background-color: #161a1d;
  border: 1px solid;
  border-color: #4e5574;
  position: relative;
  min-width: 300px;
`;

export const buttonStyle = (active: boolean) => ({
  backgroundColor: active ? "#0F9FFF" : "rgba(250,250,250,0.16)",
  color: "#fff",
  borderRadius: "15px",
  padding: "5px 10px 3px",
  textTransform: "none" as const,
  height: "27px",
});

export const BtnClose = styled.div`
  cursor: pointer;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.16);
  transition: background-color 0.3s ease;
  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

export const AboutMoleculeWrapper = styled.div<{isShow: boolean}>`
  position: absolute;
  top: 60px;
  left: -1px;
  right: -10px;
  padding: 10px 8px;
  color: #fff;
  background-color: #161a1d;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 2;
  max-width: 300px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: ${({isShow}) => (isShow ? "auto" : "0px")};
  opacity: ${({isShow}) => (isShow ? "1" : "0")};

  .aboutMoleculeHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  img {
    width: 16px;
    margin-right: 8px;
  }
`;
